/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-09-09 09:56:55
 * @LastEditors: hayuu
 * @LastEditTime: 2024-10-21 14:11:50
 */
import Vue from 'vue'
import request from '@/utils/request'
// import manage from '@/api/myApi/manage.js'
Vue.prototype.$api = {
  // 通用请求方法-需要路径
  manage: require('@/api/myApi/manage.js'),

  insert: (e) => {
    let { name, notes } = e
    let data = {
      system: "ytj",
      name: name,
      notes: notes,
      code: JSON.parse(localStorage.getItem("area")).code
    }
    return request({
      url: "/matter/commonOperationRecord/insert",
      method: 'post',
      data: data
    })
  },


}
